export default __webpack_public_path__ + "static/environment-b3efbcf3fb1cf872e349c0fece8fa032.png";